export const UNKNOWN_CATEGORY_ID = -1;
export const UNMAPPED_CATEGORY = 'UNMAPPED';
